import { Station } from '@app/core/types/stations';
import { AuditMatchCategoryNavigator } from '../../components/AuditMatchCategoryNavigator';
import { AdOverlayView } from './components/ad-overlay/AdOverlayView';
import { MentionsMatchesView } from './components/mentions/MentionsMatchesView';
import { SpotMatchesView } from './components/spot/SpotMatchesView';
import { MatchCategory } from './types';

export function MatchesRootView({ station }: { station: Station }) {
  return (
    <AuditMatchCategoryNavigator>
      {(category) => {
        if (category === MatchCategory.ADS) {
          return <SpotMatchesView station={station} />;
        }

        if (category === MatchCategory.LIVE_MENTIONS) {
          return <MentionsMatchesView station={station} />;
        }

        if (category === MatchCategory.AD_OVERLAY) {
          return <AdOverlayView station={station} />;
        }
      }}
    </AuditMatchCategoryNavigator>
  );
}
